import css from "./popUp.module.css";

export default function MainPop() {
  return (
    <div className={css.mainPopWrap}>
      <p className={css.mainPopP}>
        Пташка Час майстрів створена з першоелемента – жовтого квадрата, який
        походить від ідеї Малевича. З нього все починається. Якщо його обернути
        буде коло, протягнути – буде лінія. Так створюється набір
        першоелементів, а з них будується весь Всесвіт. Жовтий колір несе світло
        і свято. Птаха оспівує прекрасний світ. Наша птаха злітає зліва направо
        – це символ еволюції, якій ми служимо.
      </p>
    </div>
  );
}
